var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_6964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76932 8.43108C5.60347 8.33574 5.3955 8.33575 5.22965 8.43111L2.68603 9.89359C2.29177 10.1203 1.80438 9.78489 1.90915 9.359L2.5835 6.61755C2.62731 6.43945 2.56379 6.25297 2.4184 6.13287L0.179445 4.28326C-0.167367 3.99676 0.0190734 3.4556 0.47731 3.41869L3.42793 3.181C3.62007 3.16552 3.78746 3.05057 3.86295 2.88225L5.02092 0.300523C5.20065 -0.100175 5.79935 -0.100174 5.97908 0.300524L7.13705 2.88225C7.21254 3.05057 7.37993 3.16552 7.57207 3.181L10.5227 3.41869C10.9809 3.4556 11.1674 3.99676 10.8206 4.28326L8.5816 6.13287C8.43621 6.25297 8.37269 6.43945 8.4165 6.61755L9.0909 9.35919C9.19565 9.78505 8.70833 10.1204 8.31407 9.89382L5.76932 8.43108Z",
    fill: "#FFC500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_6964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.75e05f01bcc7a617dfcb44c5cf7dd69b.svg";
export { ForwardRef as ReactComponent };